import { Input, useTranslation, handleFieldUpdate } from '@testsigma/atoms';
import { useCallback } from 'react';

interface UploadFileNameProps {
  onChangeFileName: (fileName: string) => void;
  isUploadInProgress: boolean;
  setValue: (field: string, value: any) => void;
  errors: { [key: string]: { message: string } };
  watch: (field: string) => any;
}

export const UploadFileNamePanel: React.FC<UploadFileNameProps> = ({
  onChangeFileName,
  isUploadInProgress,
  setValue,
  errors,
  watch,
}) => {
  const { t } = useTranslation();

  const onChangeName = useCallback(
    (value) => {
      handleFieldUpdate({ setValue, fieldName: 'name', value });
      onChangeFileName(value);
    },
    [onChangeFileName, setValue],
  );

  return (
    <Input
      value={watch('name') || ''}
      onChange={onChangeName}
      type='text'
      label={t('common.default.field.label.name')}
      wrapperClassName='w-full'
      preventDefaultValue
      isRequired
      hasError={Boolean(errors?.name)}
      errorText={errors?.name?.message || ''}
      isDisabled={isUploadInProgress}
    />
  );
};
